// Auto-generated from Listino_Vendita_Menci.md
export interface ListinoItem { nome: string; formato: string; prezzo: number; }
export interface ListinoCategoria { categoria: string; items: ListinoItem[]; }
export const listinoMenci: ListinoCategoria[] = [
  {
    "categoria": "ORTAGGI",
    "items": [
      {
        "nome": "AGLIONE",
        "formato": "VASO 10",
        "prezzo": 13.0
      },
      {
        "nome": "ANGURIA LUNGA",
        "formato": "VASO 10",
        "prezzo": 10.0
      },
      {
        "nome": "ANGURIA MINI ROSSA",
        "formato": "VASO 10",
        "prezzo": 10.0
      },
      {
        "nome": "ANGURIA TONDA",
        "formato": "40 FORI",
        "prezzo": 8.0
      },
      {
        "nome": "ANGURIA TONDA",
        "formato": "VASO 10",
        "prezzo": 10.0
      },
      {
        "nome": "ASPARAGO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "BARBABIETOLA",
        "formato": "40 FORI",
        "prezzo": 7.0
      },
      {
        "nome": "BASILICO ALLA CANNELLA",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "BASILICO ALLA MENTA",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "BASILICO GENOVESE",
        "formato": "40 FORI",
        "prezzo": 7.0
      },
      {
        "nome": "BASILICO GENOVESE",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "BASILICO GENOVESE",
        "formato": "VASO 14",
        "prezzo": 2.0
      },
      {
        "nome": "BASILICO GRECO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "BASILICO ROMANO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "BASILICO THAILANDESE",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "BIETOLA COLORATA",
        "formato": "40 FORI",
        "prezzo": 7.0
      },
      {
        "nome": "BIETOLA COSTA FINA",
        "formato": "40 FORI",
        "prezzo": 7.0
      },
      {
        "nome": "BIETOLA COSTA LARGA",
        "formato": "40 FORI",
        "prezzo": 7.0
      },
      {
        "nome": "CARCIOFO VIOLETTO",
        "formato": "VASO 10",
        "prezzo": 13.0
      },
      {
        "nome": "CAVOLO CALABRESE",
        "formato": "40 FORI",
        "prezzo": 7.0
      },
      {
        "nome": "CAVOLO CAPPUCCIO A CUORE",
        "formato": "60 FORI",
        "prezzo": 7.0
      },
      {
        "nome": "CAVOLO CAPPUCCIO ROSSO",
        "formato": "40 FORI",
        "prezzo": 7.0
      },
      {
        "nome": "CAVOLO CAPPUCCIO ROSSO",
        "formato": "60 FORI",
        "prezzo": 7.0
      },
      {
        "nome": "CAVOLO CAPPUCCIO",
        "formato": "40 FORI",
        "prezzo": 7.0
      },
      {
        "nome": "CAVOLO CAPPUCCIO",
        "formato": "60 FORI",
        "prezzo": 7.0
      },
      {
        "nome": "CAVOLO NERO TOSCANO",
        "formato": "40 FORI",
        "prezzo": 7.0
      },
      {
        "nome": "CAVOLO NERO TOSCANO",
        "formato": "60 FORI",
        "prezzo": 7.0
      },
      {
        "nome": "CAVOLO VERZA PRECOCE",
        "formato": "40 FORI",
        "prezzo": 7.0
      },
      {
        "nome": "CAVOLO VERZA PRECOCE",
        "formato": "60 FORI",
        "prezzo": 7.0
      },
      {
        "nome": "CETRIOLO LUNGO",
        "formato": "40 FORI",
        "prezzo": 8.0
      },
      {
        "nome": "CETRIOLO LUNGO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "CETRIOLO MEZZO LUNGO",
        "formato": "40 FORI",
        "prezzo": 8.0
      },
      {
        "nome": "CETRIOLO MEZZO LUNGO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "CETRIOLO SOTTACETO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "CIPOLLA RAMATA DI MILANO",
        "formato": "120 FORI",
        "prezzo": 7.5
      },
      {
        "nome": "CIPOLLA ROSSA BASTARDA",
        "formato": "120 FORI",
        "prezzo": 7.5
      },
      {
        "nome": "CIPOLLA ROSSA BASTARDA",
        "formato": "60 FORI",
        "prezzo": 7.0
      },
      {
        "nome": "CIPOLLA ROSSA DI FIRENZE",
        "formato": "60 FORI",
        "prezzo": 7.0
      },
      {
        "nome": "CIPOLLA ROSSA PIATTA SENESE",
        "formato": "120 FORI",
        "prezzo": 7.5
      },
      {
        "nome": "CIPOLLA ROSSA PIATTA SENESE",
        "formato": "60 FORI",
        "prezzo": 7.0
      },
      {
        "nome": "CIPOLLA TROPEA LUNGA",
        "formato": "60 FORI",
        "prezzo": 7.0
      },
      {
        "nome": "FAGIOLINI",
        "formato": "40 FORI",
        "prezzo": 7.5
      },
      {
        "nome": "FRAGOLE",
        "formato": "VASO 14",
        "prezzo": 2.0
      },
      {
        "nome": "INNESTO ANGURIA LUNGA",
        "formato": "VASO 14",
        "prezzo": 2.3
      },
      {
        "nome": "INNESTO ANGURIA TONDA",
        "formato": "VASO 14",
        "prezzo": 2.3
      },
      {
        "nome": "INN. CETRIOLO",
        "formato": "VASO 14",
        "prezzo": 2.3
      },
      {
        "nome": "INNESTO MELANZANA BIANCA",
        "formato": "VASO 14",
        "prezzo": 2.3
      },
      {
        "nome": "INN. MELANZANA LUNGA",
        "formato": "VASO 14",
        "prezzo": 2.3
      },
      {
        "nome": "INNESTO MELANZANA STRIATA",
        "formato": "VASO 14",
        "prezzo": 2.3
      },
      {
        "nome": "INNESTO MELANZANA TONDA NERA",
        "formato": "VASO 14",
        "prezzo": 2.3
      },
      {
        "nome": "INNESTO MELANZANA TONDA VIOLA",
        "formato": "VASO 14",
        "prezzo": 2.3
      },
      {
        "nome": "INNESTO MELONE LISCIO",
        "formato": "VASO 14",
        "prezzo": 2.3
      },
      {
        "nome": "INNESTO MELONE RETATO",
        "formato": "VASO 14",
        "prezzo": 2.3
      },
      {
        "nome": "INN. PEPERONE CORNO GIALLO",
        "formato": "VASO 14",
        "prezzo": 2.3
      },
      {
        "nome": "INN. PEPERONE CORNO ROSSO",
        "formato": "VASO 14",
        "prezzo": 2.3
      },
      {
        "nome": "INN. PEPERONE QUADRATO GIALLO",
        "formato": "VASO 14",
        "prezzo": 2.3
      },
      {
        "nome": "INNESTO POMODORO CILIEGINO GIALLO",
        "formato": "VASO 14",
        "prezzo": 2.3
      },
      {
        "nome": "INNESTO POMODORO KOKO CENCARA",
        "formato": "VASO 14",
        "prezzo": 2.3
      },
      {
        "nome": "INN. POMODORO PACHINO",
        "formato": "VASO 14",
        "prezzo": 2.3
      },
      {
        "nome": "INNESTO POMODORO ZEBRINO",
        "formato": "VASO 14",
        "prezzo": 2.3
      },
      {
        "nome": "INS. PAC BRASILIANA",
        "formato": "60 FORI",
        "prezzo": 6.0
      },
      {
        "nome": "INS. PAC CAMARO",
        "formato": "60 FORI",
        "prezzo": 6.0
      },
      {
        "nome": "INS. PAC CANASTA COMMODORE",
        "formato": "60 FORI",
        "prezzo": 6.0
      },
      {
        "nome": "INS. PAC CANASTA INCANTO",
        "formato": "60 FORI",
        "prezzo": 6.0
      },
      {
        "nome": "INS. PAC CATALOGNA GIGANTE",
        "formato": "60 FORI",
        "prezzo": 6.0
      },
      {
        "nome": "INS. PAC GENTILINA ROSSA",
        "formato": "60 FORI",
        "prezzo": 6.0
      },
      {
        "nome": "INS. PAC GENTILINA VERDE",
        "formato": "60 FORI",
        "prezzo": 6.0
      },
      {
        "nome": "INS. PAC MISTICANZA",
        "formato": "60 FORI",
        "prezzo": 6.0
      },
      {
        "nome": "INS. PAC PALLOTTINA",
        "formato": "60 FORI",
        "prezzo": 6.0
      },
      {
        "nome": "INS. PAC PAN DI ZUCCHERO",
        "formato": "60 FORI",
        "prezzo": 6.0
      },
      {
        "nome": "INS. PAC PESCIATINA",
        "formato": "60 FORI",
        "prezzo": 6.0
      },
      {
        "nome": "INS. PAC RADICCHIO ROSSO PRECOCE",
        "formato": "60 FORI",
        "prezzo": 6.0
      },
      {
        "nome": "INS. PAC ROMANA VERDE",
        "formato": "60 FORI",
        "prezzo": 6.0
      },
      {
        "nome": "INS. BARBA DEI FRATI",
        "formato": "60 FORI",
        "prezzo": 5.5
      },
      {
        "nome": "INS. BRASILIANA",
        "formato": "60 FORI",
        "prezzo": 5.5
      },
      {
        "nome": "INS. CANASTA CAMARO",
        "formato": "60 FORI",
        "prezzo": 5.5
      },
      {
        "nome": "INS. CANASTA COMMODORE",
        "formato": "60 FORI",
        "prezzo": 5.5
      },
      {
        "nome": "INS. CANASTA INCANTO",
        "formato": "60 FORI",
        "prezzo": 5.5
      },
      {
        "nome": "INS. CATALOGNA GIGANTE",
        "formato": "60 FORI",
        "prezzo": 5.5
      },
      {
        "nome": "INS. CATALOGNA PUNTARELLE",
        "formato": "60 FORI",
        "prezzo": 5.5
      },
      {
        "nome": "INS. GENTILINA ROSSA",
        "formato": "60 FORI",
        "prezzo": 5.5
      },
      {
        "nome": "INS. GENTILINA VERDE",
        "formato": "60 FORI",
        "prezzo": 5.5
      },
      {
        "nome": "INS. PALLOTTINA",
        "formato": "60 FORI",
        "prezzo": 5.5
      },
      {
        "nome": "INS. PAN DI ZUCCHERO",
        "formato": "60 FORI",
        "prezzo": 5.5
      },
      {
        "nome": "INS. PESCIATINA",
        "formato": "60 FORI",
        "prezzo": 5.5
      },
      {
        "nome": "INS. RADICCHIO ROSSO PRECOCE",
        "formato": "60 FORI",
        "prezzo": 5.5
      },
      {
        "nome": "INS. ROMANA ROSSA",
        "formato": "60 FORI",
        "prezzo": 5.5
      },
      {
        "nome": "INS. ROMANA VERDE",
        "formato": "60 FORI",
        "prezzo": 5.5
      },
      {
        "nome": "MELANZANA BIANCA",
        "formato": "40 FORI",
        "prezzo": 8.5
      },
      {
        "nome": "MELANZANA BIANCA",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "MELANZANA LUNGA",
        "formato": "40 FORI",
        "prezzo": 8.5
      },
      {
        "nome": "MELANZANA LUNGA",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "MELANZANA OVALE NERA",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "MELANZANA STRIATA",
        "formato": "40 FORI",
        "prezzo": 8.5
      },
      {
        "nome": "MELANZANA STRIATA",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "MELANZANA TONDA VIOLETTA",
        "formato": "40 FORI",
        "prezzo": 8.5
      },
      {
        "nome": "MELANZANA TONDA VIOLETTA",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "MELONE INVERNALE BIANCO",
        "formato": "40 FORI",
        "prezzo": 8.0
      },
      {
        "nome": "MELONE INVERNALE GIALLO",
        "formato": "40 FORI",
        "prezzo": 8.0
      },
      {
        "nome": "MELONE INVERNALI VERDE",
        "formato": "40 FORI",
        "prezzo": 8.0
      },
      {
        "nome": "MELONE LISCIO TAMARIS",
        "formato": "40 FORI",
        "prezzo": 8.0
      },
      {
        "nome": "MELONE RETATO",
        "formato": "40 FORI",
        "prezzo": 8.0
      },
      {
        "nome": "MELONE RETATO",
        "formato": "VASO 10",
        "prezzo": 10.0
      },
      {
        "nome": "ORTAGGIO",
        "formato": "VASO 10",
        "prezzo": 1.0
      },
      {
        "nome": "PEPERONE CORNO TORO GIALLO",
        "formato": "40 FORI",
        "prezzo": 8.5
      },
      {
        "nome": "PEPERONE CORNO TORO GIALLO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "PEPERONE CORNO TORO ROSSO",
        "formato": "40 FORI",
        "prezzo": 8.5
      },
      {
        "nome": "PEPERONE CORNO TORO ROSSO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "PEPERONE FRIARELLO",
        "formato": "40 FORI",
        "prezzo": 8.5
      },
      {
        "nome": "PEPERONE FRIARELLO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "PEPERONE PICCANTE CILIEGIA",
        "formato": "40 FORI",
        "prezzo": 8.5
      },
      {
        "nome": "PEPERONE PICCANTE CILIEGIA",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "PEPERONE PICCANTE LUNGO",
        "formato": "40 FORI",
        "prezzo": 8.5
      },
      {
        "nome": "PEPERONE PICCANTE LUNGO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "PEPERONE PICCANTISSIMO",
        "formato": "VASO 12",
        "prezzo": 1.6
      },
      {
        "nome": "PEPERONE QUADRATO GIALLO",
        "formato": "40 FORI",
        "prezzo": 8.5
      },
      {
        "nome": "PEPERONE QUADRATO GIALLO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "PEPERONE QUADRATO ROSSO",
        "formato": "40 FORI",
        "prezzo": 8.5
      },
      {
        "nome": "PEPERONE QUADRATO ROSSO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "PEPERONE SIGARETTA",
        "formato": "VASO 10",
        "prezzo": 6.5
      },
      {
        "nome": "PICCANTISSIMO DIAVOLICCHIO",
        "formato": "VASO 12",
        "prezzo": 1.6
      },
      {
        "nome": "PICCANTISSIMO DIAVOLICCHIO",
        "formato": "VASO 10",
        "prezzo": 15.0
      },
      {
        "nome": "POMODORO A GRAPPOLO ALTEDO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "POMODORO BISTECCA",
        "formato": "40 FORI",
        "prezzo": 8.0
      },
      {
        "nome": "POMODORO BISTECCA",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "POMODORO CADILLY",
        "formato": "40 FORI",
        "prezzo": 10.0
      },
      {
        "nome": "POMODORO CADILLY",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "POMODORO CILIEGINO GIALLO",
        "formato": "40 FORI",
        "prezzo": 8.0
      },
      {
        "nome": "POMODORO CILIEGINO GIALLO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "POMODORO CILIEGINO MULTICOLOR",
        "formato": "40 FORI",
        "prezzo": 10.0
      },
      {
        "nome": "POMODORO CILIEGINO MULTICOLOR",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "POMODORO CILIEGINO ROSSO",
        "formato": "40 FORI",
        "prezzo": 8.0
      },
      {
        "nome": "POMODORO CILIEGINO ROSSO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "POMODORO CIRANO",
        "formato": "40 FORI",
        "prezzo": 8.0
      },
      {
        "nome": "POMODORO CIRANO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "POMODORO COSTIERA",
        "formato": "40 FORI",
        "prezzo": 10.0
      },
      {
        "nome": "POMODORO COSTIERA",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "POMODORO COSTOLUTO FIORENTINO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "POMODORO CUORBENGA",
        "formato": "40 FORI",
        "prezzo": 10.0
      },
      {
        "nome": "POMODORO CUORBENGA",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "POMODORO CUORE DI BUE ROSA",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "POMODORO CUORE DI BUE",
        "formato": "40 FORI",
        "prezzo": 10.0
      },
      {
        "nome": "POMODORO CUORE DI BUE",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "POMODORO DA CONSERVA DAWIL",
        "formato": "40 FORI",
        "prezzo": 8.0
      },
      {
        "nome": "POMODORO DA CONSERVA KOKO",
        "formato": "40 FORI",
        "prezzo": 10.0
      },
      {
        "nome": "POMODORO DA CONSERVA KOKO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "POMODORO DA CONSERVA MISS BETTY",
        "formato": "40 FORI",
        "prezzo": 8.0
      },
      {
        "nome": "POMODORO DA CONSERVA RIO GRANDE",
        "formato": "40 FORI",
        "prezzo": 8.0
      },
      {
        "nome": "POMODORO DATTERINO ARANCIO",
        "formato": "40 FORI",
        "prezzo": 10.0
      },
      {
        "nome": "POMODORO DATTERINO ARANCIO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "POMODORO DATTERINO GIALLO",
        "formato": "40 FORI",
        "prezzo": 10.0
      },
      {
        "nome": "POMODORO DATTERINO GIALLO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "POMODORO DATTERINO",
        "formato": "40 FORI",
        "prezzo": 10.0
      },
      {
        "nome": "POMODORO DATTERINO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "POMODORO FIORELLA",
        "formato": "40 FORI",
        "prezzo": 8.0
      },
      {
        "nome": "POMODORO FIORELLA",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "POMODORO GIALLO INVERNALE",
        "formato": "40 FORI",
        "prezzo": 8.0
      },
      {
        "nome": "POMODORO GIALLO INVERNALE",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "POMODORO GRANBORGHESE",
        "formato": "40 FORI",
        "prezzo": 8.0
      },
      {
        "nome": "POMODORO GRANBORGHESE",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "POMODORO PACHINO",
        "formato": "40 FORI",
        "prezzo": 8.0
      },
      {
        "nome": "POMODORO PACHINO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "POMODORO PERBRUZZO",
        "formato": "40 FORI",
        "prezzo": 10.0
      },
      {
        "nome": "POMODORO PERBRUZZO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "POMODORO PRELUDIO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "POMODORO RUSSO",
        "formato": "40 FORI",
        "prezzo": 8.0
      },
      {
        "nome": "POMODORO RUSSO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "POMODORO S.M. GIGANTE CORNO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "POMODORO SALENTINO",
        "formato": "40 FORI",
        "prezzo": 10.0
      },
      {
        "nome": "POMODORO SALENTINO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "POMODORO SCATOLONE",
        "formato": "40 FORI",
        "prezzo": 8.0
      },
      {
        "nome": "POMODORO SCATOLONE",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "POMODORO TONDO LISCIO EARLYSPRING",
        "formato": "40 FORI",
        "prezzo": 8.0
      },
      {
        "nome": "POMODORO TONDO LISCIO EARLYSPRING",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "POMODORO TONDO LISCIO OPTIMA",
        "formato": "40 FORI",
        "prezzo": 10.0
      },
      {
        "nome": "POMODORO TONDO LISCIO OPTIMA",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "PORRI",
        "formato": "120 FORI",
        "prezzo": 7.5
      },
      {
        "nome": "PORRI",
        "formato": "60 FORI",
        "prezzo": 7.0
      },
      {
        "nome": "PREZZEMOLO",
        "formato": "40 FORI",
        "prezzo": 7.0
      },
      {
        "nome": "PREZZEMOLO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "SCALOGNO",
        "formato": "60 FORI",
        "prezzo": 7.0
      },
      {
        "nome": "SEDANO",
        "formato": "40 FORI",
        "prezzo": 7.5
      },
      {
        "nome": "SEDANO",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "ZUCCA COSTOLUTA FIORENTINA ARIETE",
        "formato": "40 FORI",
        "prezzo": 8.0
      },
      {
        "nome": "ZUCCA COSTOLUTA FIORENTINA ARIETE",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "ZUCCA COSTOLUTA FIORENTINA FIESOLE",
        "formato": "40 FORI",
        "prezzo": 10.0
      },
      {
        "nome": "ZUCCA DA FIORE",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "ZUCCA INVERNALE",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "ZUCCA INVERNALE LUNGA GIALLA",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "ZUCCA INVERNALE TONDA VERDE",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "ZUCCA LUNGA CHIARA",
        "formato": "40 FORI",
        "prezzo": 8.0
      },
      {
        "nome": "ZUCCA LUNGA CHIARA",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "ZUCCA LUNGA SCURA",
        "formato": "40 FORI",
        "prezzo": 8.0
      },
      {
        "nome": "ZUCCA LUNGA SCURA",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "ZUCCA MOSCATA DI PROVENZA",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "ZUCCA SICILIANA",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "ZUCCA TONDA GEODE",
        "formato": "VASO 10",
        "prezzo": 7.0
      }
    ]
  },
  {
    "categoria": "AROMATICHE",
    "items": [
      {
        "nome": "ANETO",
        "formato": "VASO 14",
        "prezzo": 1.9
      },
      {
        "nome": "ASSENZIO",
        "formato": "VASO 14",
        "prezzo": 1.9
      },
      {
        "nome": "BORRAGINE",
        "formato": "VASO 14",
        "prezzo": 1.9
      },
      {
        "nome": "CAPPERO",
        "formato": "VASO 14",
        "prezzo": 5.0
      },
      {
        "nome": "CEDRINA",
        "formato": "VASO 14",
        "prezzo": 2.5
      },
      {
        "nome": "CERFOGLIO",
        "formato": "VASO 14",
        "prezzo": 1.9
      },
      {
        "nome": "CORIANDOLO",
        "formato": "VASO 14",
        "prezzo": 1.9
      },
      {
        "nome": "DRAGONCELLO",
        "formato": "VASO 14",
        "prezzo": 1.9
      },
      {
        "nome": "ELICRISIUM",
        "formato": "VASO 14",
        "prezzo": 1.9
      },
      {
        "nome": "ERBA ACETOSA",
        "formato": "VASO 14",
        "prezzo": 1.9
      },
      {
        "nome": "ERBA AGLINA",
        "formato": "VASO 14",
        "prezzo": 1.9
      },
      {
        "nome": "ERBA CIPOLLINA",
        "formato": "VASO 14",
        "prezzo": 1.6
      },
      {
        "nome": "ERBA GATTA",
        "formato": "VASO 14",
        "prezzo": 1.9
      },
      {
        "nome": "ERBA PEPE",
        "formato": "VASO 14",
        "prezzo": 1.9
      },
      {
        "nome": "ERBA SAN PIETRO",
        "formato": "VASO 14",
        "prezzo": 1.9
      },
      {
        "nome": "FINOCCHIO SELVATICO",
        "formato": "VASO 14",
        "prezzo": 1.9
      },
      {
        "nome": "LAVANDA HIDCOTE",
        "formato": "VASO 14",
        "prezzo": 2.5
      },
      {
        "nome": "LAVANDA OFFICINALIS",
        "formato": "VASO 18",
        "prezzo": 4.5
      },
      {
        "nome": "LAVANDA OFFICINALIS",
        "formato": "VASO 14",
        "prezzo": 1.6
      },
      {
        "nome": "LAVANDA STOECAS",
        "formato": "VASO 14",
        "prezzo": 3.0
      },
      {
        "nome": "LEMON GRASS",
        "formato": "VASO 14",
        "prezzo": 5.0
      },
      {
        "nome": "LEWISTICO",
        "formato": "VASO 14",
        "prezzo": 1.9
      },
      {
        "nome": "MAGGIORANA",
        "formato": "VASO 14",
        "prezzo": 1.6
      },
      {
        "nome": "MELISSA",
        "formato": "VASO 14",
        "prezzo": 1.9
      },
      {
        "nome": "MENTA",
        "formato": "VASO 14",
        "prezzo": 1.6
      },
      {
        "nome": "MENTUCCIA",
        "formato": "VASO 14",
        "prezzo": 1.6
      },
      {
        "nome": "ORIGANO",
        "formato": "VASO 14",
        "prezzo": 1.6
      },
      {
        "nome": "PIMPINELLA",
        "formato": "VASO 14",
        "prezzo": 1.9
      },
      {
        "nome": "RABARBARO",
        "formato": "VASO 14",
        "prezzo": 1.9
      },
      {
        "nome": "ROSMARINO ERETTO",
        "formato": "VASO 18",
        "prezzo": 4.5
      },
      {
        "nome": "ROSMARINO ERETTO",
        "formato": "VASO 14",
        "prezzo": 1.6
      },
      {
        "nome": "ROSMARINO REPENS",
        "formato": "VASO 18",
        "prezzo": 4.5
      },
      {
        "nome": "ROSMARINO REPENS",
        "formato": "VASO 14",
        "prezzo": 1.6
      },
      {
        "nome": "RUTA",
        "formato": "VASO 14",
        "prezzo": 1.9
      },
      {
        "nome": "SALVIA ALL'ANANAS",
        "formato": "VASO 14",
        "prezzo": 1.9
      },
      {
        "nome": "SALVIA AUREA",
        "formato": "VASO 14",
        "prezzo": 1.9
      },
      {
        "nome": "SALVIA FOGLIA LARGA",
        "formato": "VASO 14",
        "prezzo": 1.6
      },
      {
        "nome": "SALVIA FOGLIA STRETTA",
        "formato": "VASO 14",
        "prezzo": 1.6
      },
      {
        "nome": "SALVIA FOGLIA LARGA",
        "formato": "VASO 18",
        "prezzo": 4.5
      },
      {
        "nome": "SALVIA PORPUREA",
        "formato": "VASO 14",
        "prezzo": 1.9
      },
      {
        "nome": "SALVIA TRICOLOR",
        "formato": "VASO 14",
        "prezzo": 1.9
      },
      {
        "nome": "SANTOLINA",
        "formato": "VASO 14",
        "prezzo": 1.6
      },
      {
        "nome": "SANTOREGGIA",
        "formato": "VASO 14",
        "prezzo": 1.6
      },
      {
        "nome": "TIMO AUREO",
        "formato": "VASO 14",
        "prezzo": 1.6
      },
      {
        "nome": "TIMO FAUSTINI",
        "formato": "VASO 14",
        "prezzo": 1.6
      },
      {
        "nome": "TIMO LIMONE VERDE",
        "formato": "VASO 14",
        "prezzo": 1.6
      },
      {
        "nome": "TIMO VARIEGATO GRIGIO",
        "formato": "VASO 14",
        "prezzo": 1.6
      }
    ]
  },
  {
    "categoria": "PIANTE FIORITE",
    "items": [
      {
        "nome": "ACALYPHA",
        "formato": "VASO 14",
        "prezzo": 2.0
      },
      {
        "nome": "ALISSO",
        "formato": "VASO 14",
        "prezzo": 1.8
      },
      {
        "nome": "BASKET ACALYPHA",
        "formato": "VASO 20",
        "prezzo": 4.8
      },
      {
        "nome": "BASKET BEGONIA PENDULA",
        "formato": "VASO 20",
        "prezzo": 5.8
      },
      {
        "nome": "BASKET EDERA",
        "formato": "VASO 20",
        "prezzo": 4.8
      },
      {
        "nome": "BASKET FUCSIA",
        "formato": "VASO 20",
        "prezzo": 5.8
      },
      {
        "nome": "BASKET INCENSO",
        "formato": "VASO 20",
        "prezzo": 5.8
      },
      {
        "nome": "BASKET LOBELIA TRIS",
        "formato": "VASO 20",
        "prezzo": 4.8
      },
      {
        "nome": "BASKET MILLIONBELLS TRIS",
        "formato": "VASO 20",
        "prezzo": 4.8
      },
      {
        "nome": "BASKET PARIGINO",
        "formato": "VASO 20",
        "prezzo": 4.8
      },
      {
        "nome": "BASKET PELARGONIO",
        "formato": "VASO 16",
        "prezzo": 3.0
      },
      {
        "nome": "BASKET POTUNIA",
        "formato": "VASO 20",
        "prezzo": 4.8
      },
      {
        "nome": "BASKET SURFINIA VISTA",
        "formato": "VASO 20",
        "prezzo": 4.8
      },
      {
        "nome": "BASKET SURFINIA",
        "formato": "VASO 20",
        "prezzo": 4.8
      },
      {
        "nome": "BASKET TRIX",
        "formato": "VASO 20",
        "prezzo": 4.8
      },
      {
        "nome": "BASKET VERBENA TRIS",
        "formato": "VASO 20",
        "prezzo": 4.8
      },
      {
        "nome": "BEGONIA BIG",
        "formato": "VASO 14",
        "prezzo": 1.8
      },
      {
        "nome": "BEGONIA DA FOGLIA",
        "formato": "VASO 14",
        "prezzo": 2.5
      },
      {
        "nome": "BEGONIA DRAGON",
        "formato": "VASO 14",
        "prezzo": 1.8
      },
      {
        "nome": "BEGONIA OLANDESE",
        "formato": "VASO 14",
        "prezzo": 5.0
      },
      {
        "nome": "BEGONIA TUBEROSA",
        "formato": "VASO 14",
        "prezzo": 1.8
      },
      {
        "nome": "BOCCHE DI LEONE",
        "formato": "VASO 14",
        "prezzo": 1.8
      },
      {
        "nome": "BUGANVILLE A CESPUGLIO",
        "formato": "VASO 22",
        "prezzo": 30.0
      },
      {
        "nome": "CALYLOPHUS",
        "formato": "VASO 14",
        "prezzo": 2.0
      },
      {
        "nome": "CHRYSOCEPHALUM",
        "formato": "VASO 14",
        "prezzo": 2.0
      },
      {
        "nome": "COLEUS",
        "formato": "VASO 14",
        "prezzo": 1.8
      },
      {
        "nome": "COMPOSIZIONE DA ESTERNO",
        "formato": "VASO 20",
        "prezzo": 13.0
      },
      {
        "nome": "COMPOSIZIONE DA ESTERNO",
        "formato": "VASO 25",
        "prezzo": 20.0
      },
      {
        "nome": "CUPHEA",
        "formato": "VASO 14",
        "prezzo": 2.0
      },
      {
        "nome": "DALIA",
        "formato": "VASO 19",
        "prezzo": 9.5
      },
      {
        "nome": "DALIA",
        "formato": "VASO 14",
        "prezzo": 2.5
      },
      {
        "nome": "DIMORFOTECA",
        "formato": "VASO 14",
        "prezzo": 2.0
      },
      {
        "nome": "DIPLADENIA",
        "formato": "VASO 10",
        "prezzo": 3.0
      },
      {
        "nome": "DIPLADENIA",
        "formato": "VASO 14",
        "prezzo": 4.0
      },
      {
        "nome": "EUPHORBIA",
        "formato": "VASO 14",
        "prezzo": 2.0
      },
      {
        "nome": "EURIOPS",
        "formato": "VASO 18",
        "prezzo": 6.0
      },
      {
        "nome": "EURIOPS",
        "formato": "VASO 22",
        "prezzo": 8.0
      },
      {
        "nome": "EURIOPS",
        "formato": "VASO 14",
        "prezzo": 4.0
      },
      {
        "nome": "FIORI",
        "formato": "VASO 14",
        "prezzo": 1.8
      },
      {
        "nome": "FUCSIA",
        "formato": "VASO 14",
        "prezzo": 2.0
      },
      {
        "nome": "GAROFANO",
        "formato": "VASO 14",
        "prezzo": 3.0
      },
      {
        "nome": "GAZANIA",
        "formato": "VASO 14",
        "prezzo": 1.8
      },
      {
        "nome": "GER. EDERA",
        "formato": "VASO 14",
        "prezzo": 1.5
      },
      {
        "nome": "GER. PARIGINO",
        "formato": "VASO 14",
        "prezzo": 1.5
      },
      {
        "nome": "GER. PROFUMATO",
        "formato": "VASO 17",
        "prezzo": 5.0
      },
      {
        "nome": "GER. RAMPICANTI",
        "formato": "VASO 30",
        "prezzo": 13.0
      },
      {
        "nome": "GER. ZONALE",
        "formato": "VASO 14",
        "prezzo": 1.5
      },
      {
        "nome": "GERBERA",
        "formato": "VASO 14",
        "prezzo": 2.0
      },
      {
        "nome": "GONFRENIA",
        "formato": "VASO 14",
        "prezzo": 2.0
      },
      {
        "nome": "HELIOTROPHIUM VANIGLIA",
        "formato": "VASO 14",
        "prezzo": 2.0
      },
      {
        "nome": "HYPOESTER",
        "formato": "VASO 14",
        "prezzo": 2.5
      },
      {
        "nome": "INCENSO",
        "formato": "VASO 14",
        "prezzo": 2.0
      },
      {
        "nome": "IPOMEA",
        "formato": "VASO 14",
        "prezzo": 2.5
      },
      {
        "nome": "JAMESBRITTENIA",
        "formato": "VASO 14",
        "prezzo": 1.8
      },
      {
        "nome": "LANTANA CAMARA",
        "formato": "VASO 14",
        "prezzo": 2.5
      },
      {
        "nome": "LANTANA SELLOVIANA",
        "formato": "VASO 14",
        "prezzo": 2.5
      },
      {
        "nome": "LOBELIA",
        "formato": "VASO 14",
        "prezzo": 1.8
      },
      {
        "nome": "MARGHERITA BIANCA",
        "formato": "VASO 18",
        "prezzo": 6.0
      },
      {
        "nome": "MARGHERITA COLORATA",
        "formato": "VASO 14",
        "prezzo": 3.5
      },
      {
        "nome": "MILLEBACI",
        "formato": "VASO 14",
        "prezzo": 1.8
      },
      {
        "nome": "MILLIONBELLS",
        "formato": "VASO 14",
        "prezzo": 1.8
      },
      {
        "nome": "MINI VISTA",
        "formato": "VASO 14",
        "prezzo": 1.8
      },
      {
        "nome": "NUOVA GUINEA DA SOLE",
        "formato": "VASO 14",
        "prezzo": 2.5
      },
      {
        "nome": "NUOVA GUINEA",
        "formato": "VASO 14",
        "prezzo": 1.8
      },
      {
        "nome": "PER. AGATEA",
        "formato": "VASO 14",
        "prezzo": 4.0
      },
      {
        "nome": "PER. BERGENA",
        "formato": "VASO 14",
        "prezzo": 5.0
      },
      {
        "nome": "PERENNE CAMPANULA CARPATICA",
        "formato": "VASO 14",
        "prezzo": 2.5
      },
      {
        "nome": "PER. CLEOMA",
        "formato": "VASO 14",
        "prezzo": 2.5
      },
      {
        "nome": "PER. COSMOS",
        "formato": "VASO 14",
        "prezzo": 2.5
      },
      {
        "nome": "PERENNE ECHINACEA",
        "formato": "VASO 14",
        "prezzo": 2.5
      },
      {
        "nome": "PER. ERIGERON",
        "formato": "VASO 14",
        "prezzo": 2.5
      },
      {
        "nome": "PER. FESTUCA GLAUCA",
        "formato": "VASO 10",
        "prezzo": 2.0
      },
      {
        "nome": "PER. FESTUCA GLAUCA",
        "formato": "VASO 14",
        "prezzo": 2.5
      },
      {
        "nome": "PER. FESTUCA GLAUCA",
        "formato": "VASO 17",
        "prezzo": 5.0
      },
      {
        "nome": "PER. GAURA",
        "formato": "VASO 17",
        "prezzo": 5.0
      },
      {
        "nome": "PER. GAURA",
        "formato": "VASO 14",
        "prezzo": 2.5
      },
      {
        "nome": "PERENNE GERANIO ROZANNE",
        "formato": "VASO 17",
        "prezzo": 5.0
      },
      {
        "nome": "PER. LAGURUS OVATUS",
        "formato": "VASO 14",
        "prezzo": 2.5
      },
      {
        "nome": "PERENNE MARGHERITA",
        "formato": "VASO 14",
        "prezzo": 2.5
      },
      {
        "nome": "PER. MESEMBRANTEMO SEMPER FLORENS",
        "formato": "VASO 14",
        "prezzo": 3.5
      },
      {
        "nome": "PER. MESEMBRANTEMO TRICODIADEMA",
        "formato": "VASO 14",
        "prezzo": 3.5
      },
      {
        "nome": "PER. MESEMBRANTEMO",
        "formato": "VASO 14",
        "prezzo": 3.5
      },
      {
        "nome": "PERENNI MIX",
        "formato": "VASO 14",
        "prezzo": 2.5
      },
      {
        "nome": "PER. SAGINA LOBULARE",
        "formato": "VASO 14",
        "prezzo": 2.5
      },
      {
        "nome": "PER. SALVIA GREGGI",
        "formato": "VASO 14",
        "prezzo": 2.5
      },
      {
        "nome": "PER. SALVIA GREGGI",
        "formato": "VASO 30",
        "prezzo": 15.0
      },
      {
        "nome": "PER. SAXIFRAGA",
        "formato": "VASO 14",
        "prezzo": 2.5
      },
      {
        "nome": "PER. STIPA TENUISIMA",
        "formato": "VASO 14",
        "prezzo": 2.5
      },
      {
        "nome": "PER. VERBENA BONARIENSIS",
        "formato": "VASO 17",
        "prezzo": 5.0
      },
      {
        "nome": "PER. VERBENA PULKELLA",
        "formato": "VASO 14",
        "prezzo": 2.5
      },
      {
        "nome": "PORTULACCA",
        "formato": "VASO 14",
        "prezzo": 1.8
      },
      {
        "nome": "POTUNIA",
        "formato": "VASO 14",
        "prezzo": 1.8
      },
      {
        "nome": "SALVIA BLU",
        "formato": "VASO 14",
        "prezzo": 2.5
      },
      {
        "nome": "SCAEVOLA",
        "formato": "VASO 14",
        "prezzo": 1.8
      },
      {
        "nome": "STAG. ALISSO",
        "formato": "VASO 10",
        "prezzo": 6.5
      },
      {
        "nome": "STAG. BEGONIA",
        "formato": "VASO 10",
        "prezzo": 6.5
      },
      {
        "nome": "STAG. CELOSIA",
        "formato": "VASO 10",
        "prezzo": 6.5
      },
      {
        "nome": "STAG. COLEUS",
        "formato": "VASO 10",
        "prezzo": 6.5
      },
      {
        "nome": "STAG. IMPATIENS",
        "formato": "VASO 10",
        "prezzo": 6.5
      },
      {
        "nome": "STAG. PETUNIA",
        "formato": "VASO 10",
        "prezzo": 6.5
      },
      {
        "nome": "STAG. SALVIA SPENDENS",
        "formato": "VASO 10",
        "prezzo": 6.5
      },
      {
        "nome": "STAG. STATICE",
        "formato": "40 FORI",
        "prezzo": 8.0
      },
      {
        "nome": "STAG. TAGETA",
        "formato": "VASO 10",
        "prezzo": 6.5
      },
      {
        "nome": "STAG. VERBENA",
        "formato": "VASO 10",
        "prezzo": 6.5
      },
      {
        "nome": "STAG. ZINNIA",
        "formato": "40 FORI",
        "prezzo": 8.0
      },
      {
        "nome": "SURFINIA VISTA",
        "formato": "VASO 14",
        "prezzo": 1.8
      },
      {
        "nome": "SURFINIA",
        "formato": "VASO 14",
        "prezzo": 1.8
      },
      {
        "nome": "TRIS A 3 PIANTE DIVERSE",
        "formato": "VASO 14",
        "prezzo": 2.3
      },
      {
        "nome": "TRIS MILLIONBELLS",
        "formato": "VASO 14",
        "prezzo": 2.3
      },
      {
        "nome": "TRIS SURFINIA VISTA",
        "formato": "VASO 14",
        "prezzo": 2.3
      },
      {
        "nome": "VERBENA",
        "formato": "VASO 14",
        "prezzo": 1.8
      }
    ]
  },
  {
    "categoria": "COMMERCIO INTERNO",
    "items": [
      {
        "nome": "ALOE ARBORESCENS",
        "formato": "VASO 17",
        "prezzo": 12.0
      },
      {
        "nome": "ALOE VERA",
        "formato": "VASO 30",
        "prezzo": 17.0
      },
      {
        "nome": "ANTURIUM",
        "formato": "VASO 17",
        "prezzo": 13.0
      },
      {
        "nome": "ANTURIUM",
        "formato": "VASO 9",
        "prezzo": 7.0
      },
      {
        "nome": "ASPARAGINA SPRENGERI",
        "formato": "VASO 12",
        "prezzo": 4.0
      },
      {
        "nome": "BASKET CLOROPHITIUM",
        "formato": "VASO 20",
        "prezzo": 7.0
      },
      {
        "nome": "BASKET FELCE",
        "formato": "VASO 20",
        "prezzo": 10.0
      },
      {
        "nome": "BASKET POTOS",
        "formato": "VASO 20",
        "prezzo": 8.0
      },
      {
        "nome": "BASKET TRADESCANTIA",
        "formato": "VASO 20",
        "prezzo": 7.0
      },
      {
        "nome": "BONSAI",
        "formato": "VASO 15",
        "prezzo": 18.0
      },
      {
        "nome": "CACTUS",
        "formato": "VASO 10",
        "prezzo": 3.5
      },
      {
        "nome": "CACTUS",
        "formato": "VASO 5,5",
        "prezzo": 1.2
      },
      {
        "nome": "CACTUS",
        "formato": "VASO 8",
        "prezzo": 2.3
      },
      {
        "nome": "CHAMADOREA",
        "formato": "VASO 9",
        "prezzo": 2.5
      },
      {
        "nome": "CLOROPHITIUM",
        "formato": "VASO 14",
        "prezzo": 5.0
      },
      {
        "nome": "COMPOSIZIONE DA INTERNO",
        "formato": "VASO 20",
        "prezzo": 13.0
      },
      {
        "nome": "CROTON",
        "formato": "VASO 17",
        "prezzo": 25.0
      },
      {
        "nome": "DRACENA",
        "formato": "VASO 17",
        "prezzo": 12.0
      },
      {
        "nome": "ECHEVERIA COLORATA",
        "formato": "VASO 12",
        "prezzo": 5.0
      },
      {
        "nome": "EPIFILIUM",
        "formato": "VASO 9",
        "prezzo": 3.0
      },
      {
        "nome": "FICUS BENJAMINO",
        "formato": "VASO 21",
        "prezzo": 25.0
      },
      {
        "nome": "FICUS ROBUSTO",
        "formato": "VASO 26",
        "prezzo": 45.0
      },
      {
        "nome": "GARDENIA",
        "formato": "VASO 19",
        "prezzo": 16.0
      },
      {
        "nome": "GARDENIA",
        "formato": "VASO 14",
        "prezzo": 9.0
      },
      {
        "nome": "HEDERA",
        "formato": "VASO 13",
        "prezzo": 4.5
      },
      {
        "nome": "HEDERA",
        "formato": "VASO 9",
        "prezzo": 1.8
      },
      {
        "nome": "KALANDIVE",
        "formato": "VASO 11",
        "prezzo": 2.5
      },
      {
        "nome": "KALANKOE",
        "formato": "VASO 11",
        "prezzo": 2.5
      },
      {
        "nome": "KENTIA",
        "formato": "ALTO 1,30 M.",
        "prezzo": 35.0
      },
      {
        "nome": "MONSTERA",
        "formato": "VASO 17",
        "prezzo": 12.0
      },
      {
        "nome": "ORTENSIA",
        "formato": "VASO 22",
        "prezzo": 10.0
      },
      {
        "nome": "ORTENSIA",
        "formato": "VASO 30",
        "prezzo": 20.0
      },
      {
        "nome": "ORTENSIA",
        "formato": "VASO 14",
        "prezzo": 5.0
      },
      {
        "nome": "PACHIRA",
        "formato": "ALTA 70 CM",
        "prezzo": 20.0
      },
      {
        "nome": "PHALENOPSIS",
        "formato": "VASO 12",
        "prezzo": 13.0
      },
      {
        "nome": "POTOS",
        "formato": "VASO 10",
        "prezzo": 4.0
      },
      {
        "nome": "POTOS",
        "formato": "VASO 16",
        "prezzo": 5.0
      },
      {
        "nome": "ROSELLINE",
        "formato": "VASO 10",
        "prezzo": 5.5
      },
      {
        "nome": "ROSELLINE",
        "formato": "VASO 13",
        "prezzo": 7.0
      },
      {
        "nome": "SAN SEVERIA CILINDRICA",
        "formato": "VASO 17",
        "prezzo": 24.0
      },
      {
        "nome": "SAN SEVERIA NANA",
        "formato": "VASO 12",
        "prezzo": 7.0
      },
      {
        "nome": "SAN SEVERIA",
        "formato": "VASO 12",
        "prezzo": 7.0
      },
      {
        "nome": "SAN SEVERIA",
        "formato": "VASO 21",
        "prezzo": 25.0
      },
      {
        "nome": "SPATIFILIUM",
        "formato": "VASO 17",
        "prezzo": 12.0
      },
      {
        "nome": "SPATIFILIUM",
        "formato": "VASO 14",
        "prezzo": 6.0
      },
      {
        "nome": "SUCCULENTI",
        "formato": "VASO 5,5",
        "prezzo": 1.2
      },
      {
        "nome": "SUCCULENTI",
        "formato": "VASO 10",
        "prezzo": 3.5
      },
      {
        "nome": "SUCCULENTI",
        "formato": "VASO 8",
        "prezzo": 2.3
      },
      {
        "nome": "TRADESCANTIA",
        "formato": "VASO 14",
        "prezzo": 5.0
      },
      {
        "nome": "YUCCA",
        "formato": "VASO 17",
        "prezzo": 20.0
      },
      {
        "nome": "YUCCA",
        "formato": "VASO 24",
        "prezzo": 50.0
      },
      {
        "nome": "ZAMIOCULCAS",
        "formato": "VASO 17",
        "prezzo": 12.0
      }
    ]
  },
  {
    "categoria": "COMMERCIO ESTERNO",
    "items": [
      {
        "nome": "ANIGOZANTHOS",
        "formato": "VASO 15",
        "prezzo": 10.0
      },
      {
        "nome": "ARDISIA",
        "formato": "VASO 15",
        "prezzo": 14.0
      },
      {
        "nome": "AZALEA RUSTICA",
        "formato": "VASO 16",
        "prezzo": 3.0
      },
      {
        "nome": "AZALEA RUSTICA",
        "formato": "VASO 18",
        "prezzo": 4.0
      },
      {
        "nome": "AZALEA RUSTICA",
        "formato": "VASO 22",
        "prezzo": 7.0
      },
      {
        "nome": "BOSSOLO A PALLA",
        "formato": "VASO 23",
        "prezzo": 30.0
      },
      {
        "nome": "BOSSOLO A PALLA",
        "formato": "VASO 26",
        "prezzo": 30.0
      },
      {
        "nome": "BOSSOLO A PIRAMIDE",
        "formato": "VASO 21",
        "prezzo": 30.0
      },
      {
        "nome": "BOSSOLO",
        "formato": "VASO 9",
        "prezzo": 2.5
      },
      {
        "nome": "BOSSOLO",
        "formato": "VASO 14",
        "prezzo": 5.0
      },
      {
        "nome": "BUGANVILLE A SPALLIERA",
        "formato": "ALTA 1,20 M.",
        "prezzo": 27.0
      },
      {
        "nome": "BUGANVILLE IN CANNA",
        "formato": "ALTA 1,20 M.",
        "prezzo": 12.0
      },
      {
        "nome": "BUGANVILLE IN CANNA",
        "formato": "ALTO 1,60 M.",
        "prezzo": 28.0
      },
      {
        "nome": "CALLA BIANCA",
        "formato": "VASO 15",
        "prezzo": 11.0
      },
      {
        "nome": "CALLA ROSATA ZANTEDESCHIA",
        "formato": "VASO 19",
        "prezzo": 18.0
      },
      {
        "nome": "CALLISTEMO NANO",
        "formato": "VASO 19",
        "prezzo": 11.0
      },
      {
        "nome": "CALLISTEMO",
        "formato": "VASO 22",
        "prezzo": 22.0
      },
      {
        "nome": "CAMELIA",
        "formato": "VASO 19",
        "prezzo": 6.0
      },
      {
        "nome": "CAMELIA",
        "formato": "VASO 24",
        "prezzo": 15.0
      },
      {
        "nome": "CITISUS",
        "formato": "VASO 14",
        "prezzo": 6.0
      },
      {
        "nome": "CLEMATIS",
        "formato": "VASO 17",
        "prezzo": 16.0
      },
      {
        "nome": "CONIFERE",
        "formato": "VASO 9",
        "prezzo": 2.5
      },
      {
        "nome": "CONVOLVO",
        "formato": "VASO 17",
        "prezzo": 7.0
      },
      {
        "nome": "CYCAS",
        "formato": "VASO 18",
        "prezzo": 22.0
      },
      {
        "nome": "CYCAS",
        "formato": "VASO 24",
        "prezzo": 35.0
      },
      {
        "nome": "DIPLADENIA IN CANNA",
        "formato": "ALTA 80 CM",
        "prezzo": 12.0
      },
      {
        "nome": "EREMOPHILA NIVEA",
        "formato": "VASO 17",
        "prezzo": 9.0
      },
      {
        "nome": "EUOMINUS",
        "formato": "VASO 11",
        "prezzo": 4.0
      },
      {
        "nome": "EUOMINUS",
        "formato": "VASO 13",
        "prezzo": 5.0
      },
      {
        "nome": "EUOMINUS",
        "formato": "VASO 9",
        "prezzo": 2.5
      },
      {
        "nome": "GOLD CREST",
        "formato": "VASO 26",
        "prezzo": 22.0
      },
      {
        "nome": "GOLD CREST",
        "formato": "VASO 14",
        "prezzo": 6.0
      },
      {
        "nome": "GREVILLEA",
        "formato": "VASO 16",
        "prezzo": 9.0
      },
      {
        "nome": "HIBISCUS",
        "formato": "VASO 18",
        "prezzo": 14.0
      },
      {
        "nome": "HIBISCUS",
        "formato": "VASO 14",
        "prezzo": 7.0
      },
      {
        "nome": "ILEX VERDE",
        "formato": "VASO 9",
        "prezzo": 2.5
      },
      {
        "nome": "MIMOSA",
        "formato": "ALTA 70 CM",
        "prezzo": 8.0
      },
      {
        "nome": "OLIVO ALBERELLO",
        "formato": "VASO 24",
        "prezzo": 15.0
      },
      {
        "nome": "OLIVO BONSAI",
        "formato": "VASO 10",
        "prezzo": 7.0
      },
      {
        "nome": "OLIVO BONSAI",
        "formato": "VASO 15",
        "prezzo": 7.0
      },
      {
        "nome": "OLIVO BONSAI",
        "formato": "VASO 21",
        "prezzo": 16.0
      },
      {
        "nome": "PEONIA BULBOSA",
        "formato": "VASO 12",
        "prezzo": 10.0
      },
      {
        "nome": "PIANTA DEL PEPE",
        "formato": "VASO 19",
        "prezzo": 10.0
      },
      {
        "nome": "PICEA CONICA",
        "formato": "VASO 25",
        "prezzo": 15.0
      },
      {
        "nome": "PICEA CONICA",
        "formato": "VASO 9",
        "prezzo": 2.5
      },
      {
        "nome": "PLUMBAGO",
        "formato": "VASO 19",
        "prezzo": 11.0
      },
      {
        "nome": "PLUMBAGO",
        "formato": "VASO 14",
        "prezzo": 5.0
      },
      {
        "nome": "POLIGALA",
        "formato": "VASO 19",
        "prezzo": 12.0
      },
      {
        "nome": "POLIGALA",
        "formato": "VASO 24",
        "prezzo": 20.0
      },
      {
        "nome": "ROCCIOSE",
        "formato": "VASO 14",
        "prezzo": 3.5
      },
      {
        "nome": "RODODENDRO",
        "formato": "VASO 17",
        "prezzo": 11.0
      },
      {
        "nome": "SEDUM",
        "formato": "VASO 14",
        "prezzo": 3.5
      },
      {
        "nome": "SKIMMIA",
        "formato": "VASO 10",
        "prezzo": 6.0
      },
      {
        "nome": "SKIMMIA",
        "formato": "VASO 15",
        "prezzo": 9.0
      },
      {
        "nome": "SKIMMIA",
        "formato": "VASO 17",
        "prezzo": 12.0
      },
      {
        "nome": "SOLANUM JASMINOIDE IN CANNA",
        "formato": "VASO 16",
        "prezzo": 12.0
      },
      {
        "nome": "SOLANUM JASMINOIDE",
        "formato": "VASO 14",
        "prezzo": 4.0
      },
      {
        "nome": "SOLANUM RANTONETTI",
        "formato": "VASO 17",
        "prezzo": 8.0
      },
      {
        "nome": "SPINE DI CRISTO",
        "formato": "VASO 12",
        "prezzo": 3.5
      },
      {
        "nome": "SPINE DI CRISTO",
        "formato": "VASO 15",
        "prezzo": 10.0
      },
      {
        "nome": "STRICTA",
        "formato": "VASO 17",
        "prezzo": 9.0
      },
      {
        "nome": "VERONICA VARIEGATA",
        "formato": "VASO 18",
        "prezzo": 8.5
      }
    ]
  },
  {
    "categoria": "PIANTE DA ESTERNO",
    "items": [
      {
        "nome": "ABELIA",
        "formato": "VASO 18",
        "prezzo": 6.0
      },
      {
        "nome": "ACERO PALMATO",
        "formato": "VASO 24",
        "prezzo": 25.0
      },
      {
        "nome": "AGAPANTUS",
        "formato": "VASO 18",
        "prezzo": 8.0
      },
      {
        "nome": "AGRIFOGLIO VARIEGATO",
        "formato": "VASO 17",
        "prezzo": 6.0
      },
      {
        "nome": "ALLORO",
        "formato": "VASO 18",
        "prezzo": 7.0
      },
      {
        "nome": "ALLORO",
        "formato": "VASO 24",
        "prezzo": 15.0
      },
      {
        "nome": "AMPELOPSIS",
        "formato": "VASO 18",
        "prezzo": 8.0
      },
      {
        "nome": "ASPIDISTRIA",
        "formato": "VASO 25",
        "prezzo": 15.0
      },
      {
        "nome": "BAMBU'",
        "formato": "VASO 24",
        "prezzo": 25.0
      },
      {
        "nome": "BIGNONIA",
        "formato": "VASO 18",
        "prezzo": 10.0
      },
      {
        "nome": "BOSSOLO",
        "formato": "VASO 18",
        "prezzo": 6.0
      },
      {
        "nome": "BUDLEYA",
        "formato": "VASO 18",
        "prezzo": 7.0
      },
      {
        "nome": "CALYCANTUS",
        "formato": "VASO 24",
        "prezzo": 15.0
      },
      {
        "nome": "CAPRIFOGLIO",
        "formato": "ALTO 1,60 M.",
        "prezzo": 40.0
      },
      {
        "nome": "CERCIS ALBERO DI GIUDA",
        "formato": "VASO 30",
        "prezzo": 18.0
      },
      {
        "nome": "CIPRESSO",
        "formato": "ALTA 1,50 M.",
        "prezzo": 18.0
      },
      {
        "nome": "CIPRESSO",
        "formato": "ALTO 2,50 M.",
        "prezzo": 50.0
      },
      {
        "nome": "CISTUS",
        "formato": "VASO 18",
        "prezzo": 7.0
      },
      {
        "nome": "CITISUS",
        "formato": "VASO 17",
        "prezzo": 7.0
      },
      {
        "nome": "CITISUS",
        "formato": "VASO 19",
        "prezzo": 9.0
      },
      {
        "nome": "CONIFERE",
        "formato": "VASO 18",
        "prezzo": 6.0
      },
      {
        "nome": "COTONASTER SALICIFOLIA",
        "formato": "VASO 18",
        "prezzo": 6.0
      },
      {
        "nome": "CYDONIA",
        "formato": "VASO 18",
        "prezzo": 7.0
      },
      {
        "nome": "EALEAGNUS VARIEGATO",
        "formato": "VASO 18",
        "prezzo": 7.0
      },
      {
        "nome": "EALEAGNUS VERDE",
        "formato": "VASO 18",
        "prezzo": 7.0
      },
      {
        "nome": "EDERA IN CANNA",
        "formato": "VASO 16",
        "prezzo": 13.0
      },
      {
        "nome": "ESCALLONIA",
        "formato": "VASO 18",
        "prezzo": 7.0
      },
      {
        "nome": "EUOMINUS",
        "formato": "VASO 18",
        "prezzo": 7.0
      },
      {
        "nome": "FEOJA",
        "formato": "VASO 18",
        "prezzo": 7.0
      },
      {
        "nome": "FORSYTHIA",
        "formato": "VASO 18",
        "prezzo": 7.0
      },
      {
        "nome": "GELSOMINO",
        "formato": "VASO 16",
        "prezzo": 10.0
      },
      {
        "nome": "GINEPRO",
        "formato": "VASO 22",
        "prezzo": 14.0
      },
      {
        "nome": "GINESTRA DI BOSCO",
        "formato": "VASO 18",
        "prezzo": 6.0
      },
      {
        "nome": "GLICINE",
        "formato": "VASO 16",
        "prezzo": 14.0
      },
      {
        "nome": "HIBISCUS DA ESTERNO",
        "formato": "VASO 18",
        "prezzo": 10.0
      },
      {
        "nome": "HOTTUNIA",
        "formato": "VASO 14",
        "prezzo": 4.0
      },
      {
        "nome": "ILEX VARIEGATO",
        "formato": "VASO 20",
        "prezzo": 10.0
      },
      {
        "nome": "ILEX VARIEGATO",
        "formato": "VASO 24",
        "prezzo": 16.0
      },
      {
        "nome": "IPERICUM",
        "formato": "VASO 18",
        "prezzo": 6.0
      },
      {
        "nome": "LAGESTROEMIA",
        "formato": "VASO 24",
        "prezzo": 15.0
      },
      {
        "nome": "LAURO CERASO",
        "formato": "VASO 18",
        "prezzo": 6.0
      },
      {
        "nome": "LENTISCO",
        "formato": "VASO 18",
        "prezzo": 7.0
      },
      {
        "nome": "LIGUSTRO A PALLONCINO",
        "formato": "VASO 24",
        "prezzo": 45.0
      },
      {
        "nome": "LIGUSTRO CHINENSIS",
        "formato": "VASO 18",
        "prezzo": 6.0
      },
      {
        "nome": "LILLA'",
        "formato": "VASO 24",
        "prezzo": 35.0
      },
      {
        "nome": "LOROPETALO",
        "formato": "VASO 18",
        "prezzo": 8.0
      },
      {
        "nome": "LOROPETALO",
        "formato": "VASO 24",
        "prezzo": 16.0
      },
      {
        "nome": "MAGNOLIA SUSAN",
        "formato": "VASO 24",
        "prezzo": 15.0
      },
      {
        "nome": "MIRTO",
        "formato": "VASO 18",
        "prezzo": 6.0
      },
      {
        "nome": "NANDINA",
        "formato": "VASO 18",
        "prezzo": 7.0
      },
      {
        "nome": "NANDINA",
        "formato": "VASO 24",
        "prezzo": 13.0
      },
      {
        "nome": "OLEANDRO AD ALBERELLO",
        "formato": "VASO 35",
        "prezzo": 80.0
      },
      {
        "nome": "OLEANDRO",
        "formato": "VASO 18",
        "prezzo": 7.0
      },
      {
        "nome": "ORTENSIA PANICULATA",
        "formato": "VASO 16",
        "prezzo": 7.0
      },
      {
        "nome": "ORTENSIA QUERCIFOGLIA",
        "formato": "VASO 16",
        "prezzo": 7.0
      },
      {
        "nome": "ORTENSIA RUSTICA",
        "formato": "VASO 22",
        "prezzo": 12.0
      },
      {
        "nome": "ORTENSIA RUSTICA",
        "formato": "VASO 30",
        "prezzo": 28.0
      },
      {
        "nome": "ORTENSIA RUSTICA",
        "formato": "VASO 18",
        "prezzo": 7.0
      },
      {
        "nome": "PAMPAS",
        "formato": "VASO 18",
        "prezzo": 7.0
      },
      {
        "nome": "PASSIFLORA",
        "formato": "ALTO 1,60 M.",
        "prezzo": 10.0
      },
      {
        "nome": "PEROSKIA",
        "formato": "VASO 17",
        "prezzo": 5.0
      },
      {
        "nome": "PHILADELFUS",
        "formato": "VASO 18",
        "prezzo": 7.0
      },
      {
        "nome": "PHLOMIS",
        "formato": "VASO 18",
        "prezzo": 6.0
      },
      {
        "nome": "PHOTINIA",
        "formato": "VASO 18",
        "prezzo": 6.0
      },
      {
        "nome": "PHOTINIA",
        "formato": "VASO 24",
        "prezzo": 15.0
      },
      {
        "nome": "PIANTA",
        "formato": "VASO 18",
        "prezzo": 1.0
      },
      {
        "nome": "PIANTA",
        "formato": "VASO 24",
        "prezzo": 1.0
      },
      {
        "nome": "PIRACANTA IN CANNA",
        "formato": "VASO 16",
        "prezzo": 6.0
      },
      {
        "nome": "PIRACANTA NAVAHO",
        "formato": "VASO 18",
        "prezzo": 7.0
      },
      {
        "nome": "PIRACANTA NAVAHO",
        "formato": "VASO 24",
        "prezzo": 15.0
      },
      {
        "nome": "PITOSFORO NANO",
        "formato": "VASO 18",
        "prezzo": 8.0
      },
      {
        "nome": "PITOSFORO",
        "formato": "VASO 18",
        "prezzo": 8.0
      },
      {
        "nome": "POTENTILLA",
        "formato": "VASO 18",
        "prezzo": 7.0
      },
      {
        "nome": "SALICE",
        "formato": "VASO 35",
        "prezzo": 60.0
      },
      {
        "nome": "SPIREA",
        "formato": "VASO 18",
        "prezzo": 7.0
      },
      {
        "nome": "TEUCRIUM",
        "formato": "VASO 18",
        "prezzo": 6.0
      },
      {
        "nome": "VIBURNO OPULUS",
        "formato": "VASO 18",
        "prezzo": 7.0
      },
      {
        "nome": "VIBURNO",
        "formato": "VASO 18",
        "prezzo": 7.0
      },
      {
        "nome": "VITE AMERICANA",
        "formato": "VASO 16",
        "prezzo": 10.0
      }
    ]
  },
  {
    "categoria": "FRUTTI",
    "items": [
      {
        "nome": "AGR. ARANCIO",
        "formato": "VASO 21",
        "prezzo": 23.0
      },
      {
        "nome": "AGR. BERGAMOTTO",
        "formato": "VASO 21",
        "prezzo": 23.0
      },
      {
        "nome": "AGR. CEDRO",
        "formato": "VASO 21",
        "prezzo": 23.0
      },
      {
        "nome": "AGR. CHINOTTO",
        "formato": "VASO 21",
        "prezzo": 23.0
      },
      {
        "nome": "AGR. KUMQUAT",
        "formato": "VASO 21",
        "prezzo": 23.0
      },
      {
        "nome": "AGR. LIMONE EXTRA",
        "formato": "VASO 21",
        "prezzo": 26.0
      },
      {
        "nome": "AGR. LIMONE",
        "formato": "VASO 21",
        "prezzo": 23.0
      },
      {
        "nome": "AGR. LIMONE",
        "formato": "VASO 35",
        "prezzo": 70.0
      },
      {
        "nome": "AGR. MANDARINO",
        "formato": "VASO 21",
        "prezzo": 23.0
      },
      {
        "nome": "AGR. MANI DI BUDDA",
        "formato": "VASO 21",
        "prezzo": 23.0
      },
      {
        "nome": "AGR. POMPELMO",
        "formato": "VASO 21",
        "prezzo": 23.0
      },
      {
        "nome": "ALBICOCCO CREMONINI",
        "formato": "VASO 24",
        "prezzo": 13.0
      },
      {
        "nome": "ALBICOCCO PORTICI",
        "formato": "VASO 24",
        "prezzo": 13.0
      },
      {
        "nome": "CILIEGIO GIORGIA",
        "formato": "VASO 24",
        "prezzo": 13.0
      },
      {
        "nome": "CILIEGIO MORETTA DI VIGNOLA",
        "formato": "VASO 24",
        "prezzo": 13.0
      },
      {
        "nome": "CORBEZZOLO",
        "formato": "VASO 18",
        "prezzo": 7.0
      },
      {
        "nome": "CORBEZZOLO",
        "formato": "VASO 24",
        "prezzo": 18.0
      },
      {
        "nome": "FICO DOTTATO",
        "formato": "VASO 24",
        "prezzo": 13.0
      },
      {
        "nome": "FRUTTI DI BOSCO LAMPONE GIALLO",
        "formato": "VASO 18",
        "prezzo": 8.0
      },
      {
        "nome": "FRUTTI DI BOSCO LAMPONE ROSSO",
        "formato": "VASO 18",
        "prezzo": 8.0
      },
      {
        "nome": "FRUTTI DI BOSCO MIRTILLI",
        "formato": "VASO 18",
        "prezzo": 8.0
      },
      {
        "nome": "FRUTTI DI BOSCO RIBES BIANCO",
        "formato": "VASO 18",
        "prezzo": 8.0
      },
      {
        "nome": "FRUTTI DI BOSCO RIBES NERO",
        "formato": "VASO 18",
        "prezzo": 8.0
      },
      {
        "nome": "FRUTTI DI BOSCO RIBES ROSSO",
        "formato": "VASO 18",
        "prezzo": 8.0
      },
      {
        "nome": "FRUTTI DI BOSCO UVA SPINA BIANCA",
        "formato": "VASO 18",
        "prezzo": 8.0
      },
      {
        "nome": "FRUTTI DI BOSCO UVA SPINA ROSSA",
        "formato": "VASO 18",
        "prezzo": 8.0
      },
      {
        "nome": "FRUTTI",
        "formato": "VASO 24",
        "prezzo": 13.0
      },
      {
        "nome": "KAKO",
        "formato": "ALTO 2,00 M.",
        "prezzo": 80.0
      },
      {
        "nome": "KIWI FEMMINA",
        "formato": "VASO 18",
        "prezzo": 9.0
      },
      {
        "nome": "KIWI MASCHIO",
        "formato": "VASO 18",
        "prezzo": 9.0
      },
      {
        "nome": "MANDORLO DURO",
        "formato": "VASO 24",
        "prezzo": 13.0
      },
      {
        "nome": "MELO GRANNY SMITH",
        "formato": "VASO 24",
        "prezzo": 13.0
      },
      {
        "nome": "MELO ROYAL GALA",
        "formato": "VASO 24",
        "prezzo": 13.0
      },
      {
        "nome": "MELO",
        "formato": "VASO 24",
        "prezzo": 13.0
      },
      {
        "nome": "MELOGRANO",
        "formato": "VASO 18",
        "prezzo": 7.0
      },
      {
        "nome": "MELOGRANO",
        "formato": "VASO 24",
        "prezzo": 15.0
      },
      {
        "nome": "NASHI SHINSEIKI",
        "formato": "VASO 24",
        "prezzo": 13.0
      },
      {
        "nome": "NOCCIOLO",
        "formato": "VASO 24",
        "prezzo": 13.0
      },
      {
        "nome": "OLIVO DI 2 ANNI ASCOLANA",
        "formato": "VASO 16",
        "prezzo": 10.0
      },
      {
        "nome": "OLIVO DI 2 ANNI FRANTOIO",
        "formato": "VASO 16",
        "prezzo": 10.0
      },
      {
        "nome": "OLIVO DI 2 ANNI LECCINO",
        "formato": "VASO 16",
        "prezzo": 10.0
      },
      {
        "nome": "OLIVO DI 2 ANNI MORAIOLO",
        "formato": "VASO 16",
        "prezzo": 10.0
      },
      {
        "nome": "PESCO FLAVORCREST",
        "formato": "VASO 24",
        "prezzo": 13.0
      },
      {
        "nome": "PESCO PERCOCCA ANDROSS",
        "formato": "VASO 24",
        "prezzo": 13.0
      },
      {
        "nome": "PESCO PERCOCCA BABYGOLD",
        "formato": "VASO 24",
        "prezzo": 13.0
      },
      {
        "nome": "PESCO ROSSO DELLA VIGNA",
        "formato": "VASO 24",
        "prezzo": 13.0
      },
      {
        "nome": "PESCO SPRINGBELLE",
        "formato": "VASO 24",
        "prezzo": 13.0
      },
      {
        "nome": "PESCO SUNCREST",
        "formato": "VASO 24",
        "prezzo": 13.0
      },
      {
        "nome": "PESCO",
        "formato": "VASO 24",
        "prezzo": 13.0
      },
      {
        "nome": "SUSINO RAMASSIN",
        "formato": "VASO 24",
        "prezzo": 13.0
      }
    ]
  },
  {
    "categoria": "ROSE",
    "items": [
      {
        "nome": "ROSA ALBERELLO",
        "formato": "VASO 24",
        "prezzo": 22.0
      },
      {
        "nome": "ROSA F. GRANDE ALBICOCCA SFUMATO RAME",
        "formato": "VASO 19",
        "prezzo": 6.5
      },
      {
        "nome": "ROSA F. GRANDE ARANCIO SCREZIATO GIALLO",
        "formato": "VASO 19",
        "prezzo": 6.5
      },
      {
        "nome": "ROSA F. GRANDE BIANCO NEVE",
        "formato": "VASO 19",
        "prezzo": 6.5
      },
      {
        "nome": "ROSA F. GRANDE BIANCO PURO",
        "formato": "VASO 19",
        "prezzo": 6.5
      },
      {
        "nome": "ROSA F. GRANDE BIANCO ROSATO",
        "formato": "VASO 19",
        "prezzo": 6.5
      },
      {
        "nome": "ROSA F. GRANDE BICOLORE GIALLO ARANCIO",
        "formato": "VASO 19",
        "prezzo": 6.5
      },
      {
        "nome": "ROSA F. GRANDE BICOLORE ROSSO BIANCO",
        "formato": "VASO 19",
        "prezzo": 6.5
      },
      {
        "nome": "ROSA F. GRANDE BICOLORE ROSSO GIALLO",
        "formato": "VASO 19",
        "prezzo": 6.5
      },
      {
        "nome": "ROSA F. GRANDE BICOLORE VIOLA BIANCO",
        "formato": "VASO 19",
        "prezzo": 6.5
      },
      {
        "nome": "ROSA F. GRANDE GIALLO PURO",
        "formato": "VASO 19",
        "prezzo": 6.5
      },
      {
        "nome": "ROSA F. GRANDE GIALLO VIVO",
        "formato": "VASO 19",
        "prezzo": 6.5
      },
      {
        "nome": "ROSA F. GRANDE LILLA",
        "formato": "VASO 19",
        "prezzo": 6.5
      },
      {
        "nome": "ROSA F. GRANDE NERO",
        "formato": "VASO 19",
        "prezzo": 6.5
      },
      {
        "nome": "ROSA F. GRANDE ROSA ANTICO",
        "formato": "VASO 19",
        "prezzo": 6.5
      },
      {
        "nome": "ROSA F. GRANDE ROSA BENGALA",
        "formato": "VASO 19",
        "prezzo": 6.5
      },
      {
        "nome": "ROSA F. GRANDE ROSA CARICO",
        "formato": "VASO 19",
        "prezzo": 6.5
      },
      {
        "nome": "ROSA F. GRANDE ROSA SALMONE",
        "formato": "VASO 19",
        "prezzo": 6.5
      },
      {
        "nome": "ROSA F. GRANDE ROSA SFUMATO GIALLO",
        "formato": "VASO 19",
        "prezzo": 6.5
      },
      {
        "nome": "ROSA F. GRANDE ROSSO GERANIO",
        "formato": "VASO 19",
        "prezzo": 6.5
      },
      {
        "nome": "ROSA F. GRANDE ROSSO ORIENTALE",
        "formato": "VASO 19",
        "prezzo": 6.5
      },
      {
        "nome": "ROSA F. GRANDE ROSSO RUBINO",
        "formato": "VASO 19",
        "prezzo": 6.5
      },
      {
        "nome": "ROSA F. GRANDE ROSSO SCURO VELLUTATO",
        "formato": "VASO 19",
        "prezzo": 6.5
      },
      {
        "nome": "ROSA F. GRANDE ROSSO SCURO",
        "formato": "VASO 19",
        "prezzo": 6.5
      },
      {
        "nome": "ROSA F. GRANDE ROSSO VIVO",
        "formato": "VASO 19",
        "prezzo": 6.5
      },
      {
        "nome": "ROSA FIORE GRANDE A CESPUGLIO",
        "formato": "VASO 19",
        "prezzo": 6.5
      },
      {
        "nome": "ROSA PAESAGGISTICA PINK DOUBLE KNOCK OUT",
        "formato": "VASO 17",
        "prezzo": 6.0
      },
      {
        "nome": "ROSA RAMPICANTE TANTAU",
        "formato": "ALTA 1,20 M.",
        "prezzo": 13.0
      },
      {
        "nome": "ROSA RAMPICANTE",
        "formato": "ALTA 1,80 M",
        "prezzo": 13.0
      },
      {
        "nome": "ROSA TAPPEZZANTE",
        "formato": "VASO 17",
        "prezzo": 6.0
      },
      {
        "nome": "ROSA BANKSIAE",
        "formato": "VASO 18",
        "prezzo": 13.0
      }
    ]
  }
];
